export function joinStrings(separator: string, ...parts: Array<string | null | undefined>): string;
export function joinStrings(...parts: Array<string | null | undefined>): string;
export function joinStrings(...args: Array<string | null | undefined>): string {
  const [first, ...rest] = args;
  const isSeparatorProvided = typeof first === 'string' && rest.length > 0 && !/[a-zA-Z0-9]/.test(first);
  const separator = isSeparatorProvided ? first : ' ';
  const parts = isSeparatorProvided ? rest : args;

  return parts
    .map((p) => p?.trim())
    .filter((p): p is string => Boolean(p))
    .join(separator);
}
